declare const Office: any;


export const handleOpenDialog = (dialogUrl: string, width?: number, height?: number) => {
  try {
    // const dialogUrl = `${window.location.origin}/floorplan.html?dialog=true`;

    Office.context.ui.displayDialogAsync(
      dialogUrl,
      {
        height: height ?? 50,
        width: width ?? 50,
        requireHTTPS: true,
        displayInIframe: false,
        promptBeforeOpen: false,
      },
      (result: any) => {
        if (result.status === Office.AsyncResultStatus.Succeeded) {
          result.value.addEventHandler(Office.EventType.DialogMessageReceived, (arg: any) => {
            if (arg.message === "dialog-ready") {
              // console.log("Dialog is ready");
            } else if (arg.message === "close-dialog") {
              result.value.close();
            }
          });

          result.value.addEventHandler(Office.EventType.DialogEventReceived, (arg: any) => {
            // console.log("Dialog event:", arg);
          });
        } else {
          console.error("Failed to open dialog:", result.error);
        }
      }
    );
  } catch (error) {
    console.error("Error opening dialog:", error);
  }
};